var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.cl(
    'o-button',
    _vm.type,
    _vm.size,
    _vm.sharp,
    _vm.disabled,
    _vm.bold,
    _vm.bolder
  ),attrs:{"disabled":_vm.disabled,"type":_vm.nativeType},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"o-button__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }